import { render, staticRenderFns } from "./DuplicateDeliverableTemplateBtn.vue?vue&type=template&id=c86698b0&"
import script from "./DuplicateDeliverableTemplateBtn.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableTemplateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c86698b0')) {
      api.createRecord('c86698b0', component.options)
    } else {
      api.reload('c86698b0', component.options)
    }
    module.hot.accept("./DuplicateDeliverableTemplateBtn.vue?vue&type=template&id=c86698b0&", function () {
      api.rerender('c86698b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/DuplicateDeliverableTemplateBtn.vue"
export default component.exports